import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass, withModifiers as _withModifiers, renderList as _renderList, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b693efe2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "signage__container" }
const _hoisted_2 = { class: "d-flex flex-column gap flex-md-row align-items-md-center flex-grow-1" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "rooms-heading me-4" }, "Signage Layouts", -1))
const _hoisted_4 = { class: "signage__storage-quota-container mt-2 mt-md-2" }
const _hoisted_5 = { class: "signage__storage-quota-label" }
const _hoisted_6 = {
  key: 0,
  class: "dt-container"
}
const _hoisted_7 = {
  key: 0,
  class: "float-left"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Delete", -1))
const _hoisted_9 = {
  key: 1,
  class: "d-flex justify-content-between align-items-center"
}
const _hoisted_10 = { class: "ms-0 mb-2 me-2" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Delete", -1))
const _hoisted_12 = { class: "px-1" }
const _hoisted_13 = { class: "d-flex flex-row my-3" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "expanded-table__heading" }, "Name: ", -1))
const _hoisted_15 = { class: "d-flex flex-row" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "expanded-table__heading" }, "Signage List: ", -1))
const _hoisted_17 = ["onClick"]
const _hoisted_18 = { class: "d-flex flex-row mb-3" }
const _hoisted_19 = { class: "ms-auto" }
const _hoisted_20 = {
  key: 0,
  class: "layout-preview"
}
const _hoisted_21 = {
  class: "icon--small icon--white",
  viewBox: "0 0 24 24"
}
const _hoisted_22 = ["d"]
const _hoisted_23 = { class: "signage__layout-types" }
const _hoisted_24 = ["onClick"]
const _hoisted_25 = ["src"]
const _hoisted_26 = { class: "dialog-footer" }
const _hoisted_27 = { class: "mx-5" }
const _hoisted_28 = { class: "dialog-footer" }
const _hoisted_29 = { class: "m-0" }
const _hoisted_30 = { class: "el-dialog__sub-title" }
const _hoisted_31 = { class: "list-unstyled d-flex flex-column gap-1 p-1 m-0" }
const _hoisted_32 = { key: 0 }
const _hoisted_33 = { key: 0 }
const _hoisted_34 = { key: 1 }
const _hoisted_35 = { class: "m-0" }
const _hoisted_36 = { class: "dialog-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_progress = _resolveComponent("el-progress")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_TierLimit = _resolveComponent("TierLimit")!
  const _component_Icon = _resolveComponent("Icon")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_SignageLayoutPreview = _resolveComponent("SignageLayoutPreview")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_router_link = _resolveComponent("router-link")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass({'d-flex align-items-center justify-items-between' : _ctx.windowWidth.value >= 576 })
    }, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("span", _hoisted_5, [
            _createTextVNode(" Storage Used: "),
            _withDirectives((_openBlock(), _createElementBlock("span", null, [
              (_ctx.assetCapacityGb)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createTextVNode(_toDisplayString(_ctx.usedStorageToSize) + " / " + _toDisplayString(_ctx.assetCapacityGb) + " " + _toDisplayString(_ctx.memoryUnitCheck), 1)
                  ], 64))
                : _createCommentVNode("", true)
            ])), [
              [_directive_loading, _ctx.isSignageQuotaLoading]
            ])
          ]),
          _createVNode(_component_el_tooltip, {
            effect: "dark",
            content: _ctx.assetQuotaPercentage.toFixed(2) + '%',
            placement: "bottom",
            "hide-after": 0,
            "show-after": 500
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_progress, {
                class: "signage__storage-quota-progress",
                "show-text": false,
                "stroke-width": 16,
                percentage: _ctx.assetQuotaPercentage
              }, null, 8, ["percentage"])
            ]),
            _: 1
          }, 8, ["content"])
        ])
      ]),
      _createElementVNode("div", {
        class: _normalizeClass({'mt-3 text-end' : _ctx.windowWidth.value < 576 })
      }, [
        _withDirectives((_openBlock(), _createBlock(_component_el_button, {
          class: "ms-4",
          disabled: _ctx.isNewSignageLayoutLoading,
          type: "primary",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isCreationModalVisible=true))
        }, {
          default: _withCtx(() => [
            _createTextVNode("New Layout")
          ]),
          _: 1
        }, 8, ["disabled"])), [
          [_directive_loading, _ctx.isNewSignageLayoutLoading]
        ])
      ], 2)
    ], 2),
    (_ctx.showListManagementTierCallout)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createVNode(_component_TierLimit, {
            isCallout: true,
            message: "Upgrade your Ditto account to unlock more features."
          })
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass(["dt-container", {'p-3' : _ctx.windowWidth.value < 576}])
    }, [
      (_ctx.windowWidth.value < 576)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createVNode(_component_el_input, {
              modelValue: _ctx.signageLayoutsFilter,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.signageLayoutsFilter) = $event)),
              placeholder: "Filter signage layouts",
              clearable: "",
              class: "mb-2"
            }, {
              prefix: _withCtx(() => [
                _createVNode(_component_Icon, {
                  class: "signage__layout-search-icon",
                  icon: _ctx.mdiMagnify
                }, null, 8, ["icon"])
              ]),
              _: 1
            }, 8, ["modelValue"]),
            _createVNode(_component_el_button, {
              class: "el-button--default ms-0 mb-2 me-2",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.deleteSignageLayoutPrompt())),
              disabled: _ctx.selectedSignageLayouts && !_ctx.selectedSignageLayouts.length
            }, {
              default: _withCtx(() => [
                _createVNode(_component_Icon, { icon: _ctx.mdiDelete }, null, 8, ["icon"]),
                _hoisted_8
              ]),
              _: 1
            }, 8, ["disabled"])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_9, [
            _createVNode(_component_el_tooltip, {
              disabled: !_ctx.selectedSignageLayouts.length || _ctx.hasListManagement,
              effect: "dark",
              content: _ctx.upgradeText,
              placement: "bottom",
              "hide-after": 0,
              "show-after": 500
            }, {
              default: _withCtx(() => [
                _createElementVNode("span", _hoisted_10, [
                  _createVNode(_component_el_button, {
                    class: "el-button el-button--default",
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.deleteSignageLayoutPrompt())),
                    disabled: (_ctx.selectedSignageLayouts && !_ctx.selectedSignageLayouts.length) || !_ctx.hasListManagement
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_Icon, { icon: _ctx.mdiDelete }, null, 8, ["icon"]),
                      _hoisted_11
                    ]),
                    _: 1
                  }, 8, ["disabled"])
                ])
              ]),
              _: 1
            }, 8, ["disabled", "content"]),
            _createVNode(_component_el_input, {
              modelValue: _ctx.signageLayoutsFilter,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.signageLayoutsFilter) = $event)),
              placeholder: "Filter signage layouts",
              clearable: "",
              class: "signage__layout-search my-auto"
            }, {
              prefix: _withCtx(() => [
                _createVNode(_component_Icon, {
                  class: "signage__layout-search-icon",
                  icon: _ctx.mdiMagnify
                }, null, 8, ["icon"])
              ]),
              _: 1
            }, 8, ["modelValue"])
          ])),
      (_ctx.filteredSignageLayouts)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
            _withDirectives((_openBlock(), _createBlock(_component_el_table, {
              "empty-text": "No signage layouts",
              onSelectionChange: _ctx.handleSelectionChange,
              "label-position": "top",
              ref: "signageLayoutsTable",
              onRowClick: _ctx.onRowClick,
              onSortChange: _ctx.handleSortChange,
              data: _ctx.filteredSignageLayouts,
              "default-sort": { prop: 'name', order: 'ascending' },
              style: {"width":"100%"},
              class: "signage__table"
            }, {
              default: _withCtx(() => [
                (_ctx.windowWidth.value < 576)
                  ? (_openBlock(), _createBlock(_component_el_table_column, {
                      key: 0,
                      type: "expand",
                      width: "55"
                    }, {
                      default: _withCtx((props) => [
                        _createElementVNode("div", _hoisted_12, [
                          _createElementVNode("div", _hoisted_13, [
                            _hoisted_14,
                            _createElementVNode("div", null, _toDisplayString(props.row.name), 1)
                          ]),
                          _createElementVNode("div", _hoisted_15, [
                            _hoisted_16,
                            _createElementVNode("a", {
                              class: "expanded-table__description",
                              onClick: _withModifiers(($event: any) => (_ctx.onSignageListClick(props.row)), ["stop"])
                            }, _toDisplayString(_ctx.signageListsForLayout(props.row.id).length), 9, _hoisted_17)
                          ]),
                          _createElementVNode("div", _hoisted_18, [
                            _createElementVNode("div", _hoisted_19, [
                              _createVNode(_component_el_button, {
                                type: "danger",
                                circle: "",
                                plain: "",
                                onClick: ($event: any) => (_ctx.deleteSignageLayoutPrompt(props.row))
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_Icon, {
                                    class: "dt-icon--large",
                                    icon: _ctx.mdiDelete
                                  }, null, 8, ["icon"])
                                ]),
                                _: 2
                              }, 1032, ["onClick"])
                            ])
                          ])
                        ])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                _createVNode(_component_el_table_column, {
                  type: "selection",
                  width: "55"
                }),
                (_ctx.windowWidth.value >= 576)
                  ? (_openBlock(), _createBlock(_component_el_table_column, {
                      key: 1,
                      sortable: "custom",
                      label: "Name",
                      prop: "name"
                    }))
                  : _createCommentVNode("", true),
                _createVNode(_component_el_table_column, {
                  label: "Layout",
                  prop: "layout",
                  width: "320"
                }, {
                  default: _withCtx((props) => [
                    (props.row.layout && props.row.layout.thumbUrl)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                          _createVNode(_component_SignageLayoutPreview, {
                            style: {"transform":"scale(0.15)","transform-origin":"top left"},
                            signageLayout: _ctx.getZoneContent(props.row),
                            showEdit: false
                          }, null, 8, ["signageLayout"])
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }),
                (_ctx.windowWidth.value >= 576)
                  ? (_openBlock(), _createBlock(_component_el_table_column, {
                      key: 2,
                      label: "Signage Lists",
                      prop: "lists",
                      align: "center"
                    }, {
                      default: _withCtx((props) => [
                        _createVNode(_component_el_button, {
                          type: "text",
                          onClick: _withModifiers(($event: any) => (_ctx.onSignageListClick(props.row)), ["stop"])
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.signageListsForLayout(props.row.id).length), 1)
                          ]),
                          _: 2
                        }, 1032, ["onClick"])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (_ctx.windowWidth.value >= 576)
                  ? (_openBlock(), _createBlock(_component_el_table_column, {
                      key: 3,
                      prop: "id",
                      "class-name": "el-table-row__delete"
                    }, {
                      default: _withCtx((scope) => [
                        _createVNode(_component_el_button, {
                          disabled: _ctx.isSignageLayoutsLoading,
                          class: "el-table-row__delete-button",
                          type: "danger",
                          id: scope.row.id,
                          onClick: _withModifiers(($event: any) => (_ctx.deleteSignageLayoutPrompt(scope.row)), ["stop"]),
                          circle: ""
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(), _createElementBlock("svg", _hoisted_21, [
                              _createElementVNode("path", { d: _ctx.mdiDelete }, null, 8, _hoisted_22)
                            ]))
                          ]),
                          _: 2
                        }, 1032, ["disabled", "id", "onClick"])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["onSelectionChange", "onRowClick", "onSortChange", "data"])), [
              [_directive_loading, _ctx.isSignageLayoutsLoading]
            ]),
            _createVNode(_component_el_pagination, {
              class: "mt-3 d-flex justify-content-end",
              "current-page": _ctx.pageIndex,
              "page-size": _ctx.pageSize,
              total: _ctx.signageLayoutsTotal,
              layout: "prev, pager, next, total",
              onCurrentChange: _ctx.onPageChange
            }, null, 8, ["current-page", "page-size", "total", "onCurrentChange"])
          ], 64))
        : _createCommentVNode("", true)
    ], 2),
    _createVNode(_component_el_dialog, {
      title: "New Signage Layout",
      "custom-class": "signage__creation-dialog",
      modelValue: _ctx.isCreationModalVisible,
      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.isCreationModalVisible) = $event)),
      onClose: _ctx.onCancelLayoutCreation
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_26, [
          _createVNode(_component_el_button, { onClick: _ctx.onCancelLayoutCreation }, {
            default: _withCtx(() => [
              _createTextVNode("Cancel")
            ]),
            _: 1
          }, 8, ["onClick"]),
          _withDirectives((_openBlock(), _createBlock(_component_el_button, {
            disabled: !_ctx.selectedLayout || !_ctx.selectedLayout.id,
            onClick: _ctx.createSignageLayout,
            type: "primary"
          }, {
            default: _withCtx(() => [
              _createTextVNode("Create")
            ]),
            _: 1
          }, 8, ["disabled", "onClick"])), [
            [_directive_loading, _ctx.isNewSignageLayoutLoading]
          ])
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          onSubmit: _withModifiers(_ctx.createSignageLayout, ["prevent"]),
          ref: "signageLayoutCreationForm",
          model: _ctx.signageLayoutDraft,
          rules: _ctx.signageLayoutCreationFormRules,
          "label-position": "top",
          "label-width": "120px",
          "hide-required-asterisk": "true"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              class: "p-3 m-0",
              label: "Signage Layout Name",
              prop: "name"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  class: "mt-2",
                  placeholder: "Enter Layout Name",
                  modelValue: _ctx.signageLayoutDraft.name,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.signageLayoutDraft.name) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              class: "p-3 m-0",
              label: "Select Layout",
              prop: "layout"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_23, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allLayouts, (layout, index) => {
                    return (_openBlock(), _createElementBlock("button", {
                      type: "button",
                      onClick: ($event: any) => (_ctx.onSelectLayout(layout)),
                      key: index,
                      class: _normalizeClass(["signage__layout-type-button", { active: _ctx.selectedLayout && _ctx.selectedLayout.id == layout.id}])
                    }, [
                      _createElementVNode("img", {
                        class: "m-0",
                        src: layout.thumbUrl
                      }, null, 8, _hoisted_25)
                    ], 10, _hoisted_24))
                  }), 128))
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["onSubmit", "model", "rules"])
      ]),
      _: 1
    }, 8, ["modelValue", "onClose"]),
    _createVNode(_component_el_dialog, {
      title: _ctx.signageListModalTitle,
      "custom-class": "signage__creation-dialog",
      modelValue: _ctx.isSignageListModalVisible,
      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.isSignageListModalVisible) = $event))
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_28, [
          _createVNode(_component_el_button, {
            onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.isSignageListModalVisible = false))
          }, {
            default: _withCtx(() => [
              _createTextVNode("Close")
            ]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_27, [
          _createVNode(_component_el_table, {
            data: _ctx.selectedLayoutLists,
            "show-header": false,
            "max-height": "250",
            "empty-text": "No signage lists"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_table_column, null, {
                default: _withCtx((scope) => [
                  _createVNode(_component_router_link, {
                    to: `/signage/${scope.row.id}`
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(scope.row.name), 1)
                    ]),
                    _: 2
                  }, 1032, ["to"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["data"])
        ])
      ]),
      _: 1
    }, 8, ["title", "modelValue"]),
    _withDirectives((_openBlock(), _createBlock(_component_el_dialog, {
      modelValue: _ctx.deleteConfirmationModal,
      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.deleteConfirmationModal) = $event)),
      onClose: _ctx.onCancelLayoutDeletion
    }, {
      title: _withCtx(() => [
        _createElementVNode("h2", _hoisted_29, "Delete Signage Layout" + _toDisplayString(_ctx.signageLayoutsToDelete.length == 1 ? '' : 's'), 1),
        _createElementVNode("p", _hoisted_30, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.signageLayoutsToDelete.slice(0,2), (layout, index) => {
            return (_openBlock(), _createElementBlock("span", {
              key: layout.id
            }, [
              _createTextVNode(_toDisplayString(layout.name), 1),
              (index < _ctx.signageLayoutsToDelete.length - 1)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createTextVNode(", ")
                  ], 64))
                : _createCommentVNode("", true)
            ]))
          }), 128)),
          (_ctx.signageLayoutsToDelete.length > 2)
            ? (_openBlock(), _createBlock(_component_el_tooltip, {
                key: 0,
                "show-after": 200,
                placement: "bottom"
              }, {
                content: _withCtx(() => [
                  _createElementVNode("ul", _hoisted_31, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.signageLayoutsToDelete.slice(2, _ctx.signageLayoutsToDelete.length), (layout) => {
                      return (_openBlock(), _createElementBlock("li", {
                        key: layout.id
                      }, _toDisplayString(layout.name), 1))
                    }), 128))
                  ])
                ]),
                default: _withCtx(() => [
                  _createElementVNode("span", null, "and " + _toDisplayString(_ctx.signageLayoutsToDelete.length - 2) + " more.", 1)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ])
      ]),
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_36, [
          _createVNode(_component_el_button, { onClick: _ctx.onCancelLayoutDeletion }, {
            default: _withCtx(() => [
              _createTextVNode("Cancel")
            ]),
            _: 1
          }, 8, ["onClick"]),
          _withDirectives((_openBlock(), _createBlock(_component_el_button, {
            type: "danger",
            onClick: _ctx.deleteSignageLayout,
            disabled: _ctx.layoutsToDeleteWithLists && _ctx.layoutsToDeleteWithLists.length > 0
          }, {
            default: _withCtx(() => [
              _createTextVNode("Delete")
            ]),
            _: 1
          }, 8, ["onClick", "disabled"])), [
            [_directive_loading, _ctx.isSignageLayoutDeleteLoading]
          ])
        ])
      ]),
      default: _withCtx(() => [
        (_ctx.layoutsToDeleteWithLists && _ctx.layoutsToDeleteWithLists.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
              _createElementVNode("p", null, [
                (_ctx.signageLayoutsToDelete.length > 1)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_33, "One or more selected layouts have been assigned to a signage list."))
                  : _createCommentVNode("", true),
                _createTextVNode(" A layout that has been assigned to a signage list cannot be deleted.")
              ])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_34, [
              _createElementVNode("p", null, "This action will delete the selected signage layout" + _toDisplayString(_ctx.signageLayoutsToDelete.length == 1 ? '' : 's') + ".", 1),
              _createElementVNode("p", _hoisted_35, "Are you sure you want to delete " + _toDisplayString(_ctx.signageLayoutsToDelete.length == 1 ? _ctx.signageLayoutsToDelete[0].name : `${ _ctx.signageLayoutsToDelete.length } signage layouts`) + "?", 1)
            ]))
      ]),
      _: 1
    }, 8, ["modelValue", "onClose"])), [
      [_directive_loading, true]
    ]),
    _createVNode(_component_TierLimit, {
      modelValue: _ctx.showLayoutTierWarning,
      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.showLayoutTierWarning) = $event)),
      isCallout: false,
      isLimit: false,
      message: "Upgrade your Ditto account to unlock layouts."
    }, null, 8, ["modelValue"])
  ]))
}